import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { checkinCommonReducer } from './checkin-common.reducer';
import { CHECKIN_COMMON_STORE_NAME, CheckinCommonState } from './checkin-common.state';

/** Token of the CheckinCommon reducer */
export const CHECKIN_COMMON_REDUCER_TOKEN = new InjectionToken<ActionReducer<CheckinCommonState, Action>>(
  'Feature CheckinCommon Reducer'
);

/** Provide default reducer for CheckinCommon store */
export function getDefaultCheckinCommonReducer() {
  return checkinCommonReducer;
}

@NgModule({
  imports: [StoreModule.forFeature(CHECKIN_COMMON_STORE_NAME, CHECKIN_COMMON_REDUCER_TOKEN)],
  providers: [{ provide: CHECKIN_COMMON_REDUCER_TOKEN, useFactory: getDefaultCheckinCommonReducer }],
})
export class CheckinCommonStoreModule {
  public static forRoot<T extends CheckinCommonState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinCommonStoreModule> {
    return {
      ngModule: CheckinCommonStoreModule,
      providers: [{ provide: CHECKIN_COMMON_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
